"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _jquery = _interopRequireDefault(require("jquery"));

var ComponentData =
/*#__PURE__*/
function () {
  function ComponentData(properties) {
    (0, _classCallCheck2.default)(this, ComponentData);

    _jquery.default.extend(this, properties);
  } // Extend to init more data


  (0, _createClass2.default)(ComponentData, [{
    key: "init",
    value: function init(grade) {
      this.setGrade(grade);
      this.setGradeType(grade);
      this.setDisplayValue(grade);
      return this;
    }
  }, {
    key: "setGrade",
    value: function setGrade(grade) {
      this.resultGrade = grade;
    } // Override to set specific type

  }, {
    key: "setGradeType",
    value: function setGradeType() {} // Override to set specific display values

  }, {
    key: "setDisplayValue",
    value: function setDisplayValue() {}
  }]);
  return ComponentData;
}();

var _default = ComponentData;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/data/components/ComponentData.js
// module id = 100
// module chunks = 0